export const ArrowRight = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6894_60795)">
            <path d="M17 4L29 16L17 28V22H9V10H17V4Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M5 22V10" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
            <clipPath id="clip0_6894_60795">
            <rect width="32" height="32" fill="white"/>
            </clipPath>
            </defs>
        </svg>
    )
}